import { useCallback } from 'react';

import { useTrackChangedVideoVolume } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';

export const usePlayerVolumeChange = () => {
  const videoElement = usePlayerStore((state) => state.videoElement);
  const id = usePlayerStore((state) => state.id);
  const { trackChangedVideoVolume } = useTrackChangedVideoVolume();

  const onPlayerVolumeChange = useCallback(
    (value: number) => {
      if (videoElement) {
        videoElement.volume = value;

        if (value === 0) {
          videoElement.muted = true;
        } else {
          videoElement.muted = false;
        }

        trackChangedVideoVolume({ id, volume: value });
      }
    },
    [videoElement, id, trackChangedVideoVolume],
  );

  const onPlayerVolumeDecrease = useCallback(
    (step: number) => {
      if (videoElement) {
        const newVolume = Math.max(0, videoElement.volume - step);

        videoElement.volume = newVolume;

        if (newVolume === 0) {
          videoElement.muted = true;
        }

        trackChangedVideoVolume({ id, volume: newVolume });
      }
    },
    [videoElement, id, trackChangedVideoVolume],
  );

  const onPlayerVolumeIncrease = useCallback(
    (step: number) => {
      if (videoElement) {
        const newVolume = Math.min(1, videoElement.volume + step);

        videoElement.volume = newVolume;

        if (videoElement.muted) {
          videoElement.muted = false;
        }

        trackChangedVideoVolume({ id, volume: newVolume });
      }
    },
    [videoElement, id, trackChangedVideoVolume],
  );

  return { onPlayerVolumeChange, onPlayerVolumeDecrease, onPlayerVolumeIncrease };
};
